import { Toaster } from 'react-hot-toast';
import './App.css';
import Routing from './Routing';

function App() {
  return (
    <>
      <Toaster
        position="top-center"
        toastOptions={{
          style: {
            background: "#181c24",
            color: "#e8eaf0",
            border: "1px solid rgba(255,255,255,0.08)",
          },
          success: {
            iconTheme: {
              primary: "#10b981",
              secondary: "#181c24",
            },
          },
          error: {
            iconTheme: {
              primary: "#ef4444",
              secondary: "#181c24",
            },
          },
        }}
      />
      <Routing />
    </>
  );
}

export default App;
